import React, { FC } from 'react'
import { Order, Quote, SavedCart, SharedList } from '@src/types/graphql-types'
import SavedCartsModal from './SavedCartsModal'
import QuotesModal from './QuotesModal/QuotesModal'
import RecentOrdersModal from './RecentOrdersModal'
import { QuickOrderModalContentType } from '@src/components/QuickOrder/utils'
import ListsModal from './ListsModal'

const AddToOrderModal: FC<{
  contentType: QuickOrderModalContentType
  onClose: () => void
  open: boolean
  order: Order | null
  quote: Quote | null
  savedCart: SavedCart | null
  list: SharedList | null
}> = ({ contentType, onClose, open, order, quote, savedCart, list }) => {
  switch (contentType) {
    case QuickOrderModalContentType.List:
      if (!list) return null
      return <ListsModal onClose={() => onClose()} open={open} list={list} />
    case QuickOrderModalContentType.SavedCart:
      if (!savedCart) return null
      return (
        <SavedCartsModal
          onClose={() => onClose()}
          open={open}
          savedCart={savedCart}
        />
      )
    case QuickOrderModalContentType.Quote:
      if (!quote) return null
      return <QuotesModal onClose={() => onClose()} open={open} quote={quote} />
    case QuickOrderModalContentType.Order:
    default:
      if (!order) return null
      return (
        <RecentOrdersModal
          onClose={() => onClose()}
          open={open}
          order={order}
        />
      )
  }
}

export default AddToOrderModal
